import { z } from 'zod'
import { ContactType, type Contact } from '~/domain/shared/contacts/models/Contact'

const ContactTypeEnum = z.enum(['email', 'mobile', 'phone', 'custom', 'whatsapp'])
type ContactTypeEnum = z.infer<typeof ContactTypeEnum>

export const ContactDTO = z.object({
  id: z.number().nullish(),
  type: ContactTypeEnum,
  value: z.string().nullish()
})

export type ContactDTO = z.infer<typeof ContactDTO>

export function mapContactToDTO (contact: Contact): ContactDTO {
  return {
    id: contact.id,
    value: contact.value,
    type:
      (Object.entries(contactTypeMap)
        .find(([_, v]) => v === contact.type)?.[0]
        ?.toLocaleLowerCase() as ContactTypeEnum) ?? 'custom'
  }
}

export function mapDTOToContact (dto: ContactDTO): Contact {
  return {
    id: dto?.id ?? undefined,
    type: contactTypeMap[dto?.type?.toUpperCase() ?? 'OTHER'] ?? ContactType.Custom,
    value: dto?.value ?? ''
  }
}

const contactTypeMap: { [key: string]: ContactType } = {
  EMAIL: ContactType.Email,
  MOBILE: ContactType.MobileNumber,
  PHONE: ContactType.PhoneNumber,
  OTHER: ContactType.Custom,
  WHATSAPP: ContactType.Whatsapp
}
